/**
 * Recursively flattens a nested message object into dot-notation keys,
 * keeping only string leaf values (strips booleans, objects, etc.).
 *
 * { a: { b: "text" } } → { "a.b": "text" }
 */
export function flattenMessages(obj: Record<string, unknown>, prefix = ''): Record<string, string> {
  return Object.entries(obj).reduce<Record<string, string>>((acc, [key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key
    if (typeof value === 'string') {
      acc[fullKey] = value
    } else if (typeof value === 'object' && value !== null) {
      Object.assign(acc, flattenMessages(value as Record<string, unknown>, fullKey))
    }
    return acc
  }, {})
}
